import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';

class Image extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['square', 'circle', 'rounded']),
    className: PropTypes.string,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    type: 'square',
    className: undefined,
    placeholder: undefined,
  };

  constructor(props) {
    super(props);

    const isBrowser = typeof window !== 'undefined';
    this.state = { loadingImage: isBrowser };

    if (isBrowser) {
      this.img = new global.Image();
      this.img.onload = () => this.setState({ loadingImage: false });
    }
  }

  componentDidMount() {
    this.loadImage(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.loadImage(nextProps);
    }
  }

  componentWillUnmount() {
    if (this.img) {
      this.img.onload = null;
    }
  }

  loadImage({ src }) {
    this.setState({ loadingImage: true });
    this.img.src = src;
  }

  render() {
    const { alt, src, className, type, classes, placeholder, ...other } = this.props;
    const { loadingImage } = this.state;

    return (
      <img
        alt={alt}
        src={(loadingImage && placeholder) || src}
        className={classNames(
          classes.root,
          loadingImage && placeholder && classes.placeholder,
          classes[type],
          className,
        )}
        {...other}
      />
    );
  }
}

const stylesheet = {
  root: {
    display: 'block',
    width: 'auto',
    height: 'auto',
    overflow: 'hidden',
    color: 'transparent',
    fontSize: 0,
    userSelect: 'none',
    '&$placeholder': {
      // Increase specificity to prevent GridItem to override
      objectFit: 'cover',
      objectPosition: 'top left',
    },
  },
  placeholder: {},
  circle: {
    borderRadius: '50%',
  },
  rounded: {
    borderRadius: 16,
  },
};

export default injectSheet(stylesheet)(Image);



// WEBPACK FOOTER //
// ./src/site-render/src/Image/Image.js